import { ChangeEvent, useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

const useLessonListView = () => {
    const { readFirestore } = useFirestore();
    const {getBranchId} = useGetBranchId();
    const [search, setSearch] = useState<string>('');
    const [lists, setLists] = useState<any[]>([]);
    const [searchedLists, setSearchedLists] = useState<any[]>([]);
    useEffect(() => {
        // eslint-disable-next-line
        getLessonList();
    }, [])

    const getLessonList = async() => {
        const branch_id = await getBranchId();
        readFirestore(`Lesson/Branch/${branch_id}`).then(res => {
            res.forEach((doc:any) => {
                
                setLists(prev => [...prev, {...doc.data(), id:doc.id}])
                setSearchedLists(prev => [...prev, {...doc.data(), id:doc.id}])
            })
        })
    }

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    }

    const onRefreshClick = () => {
        setLists([]);
        setSearchedLists([]);
        getLessonList();
    }

    useEffect(() => {
        const searchedItems = lists.filter((item) => item["name"].includes(search));
        setSearchedLists(searchedItems);
        // eslint-disable-next-line
    }, [search])

    return {search, searchedLists, onRefreshClick, onChange}
}

export default useLessonListView;